module.exports = __webpack_public_path__ + "static/media/2.52f47036.jpg";